import "./app.scss";
import Home from "./components/home/Home";
import Minting from "./components/minting/Minting";
import Topbar from "./components/topbar/Topbar"
import Utility from "./components/utility/Utility";
import History from "./components/history/History";
import Nokkers from "./components/nokkers/Nokkers";
import Noktypes from "./components/noktypes/Noktypes";
import Epilogue from "./components/epilogue/Epilogue";
import Faq from "./components/faq/Faq";
import Footer from "./components/footer/Footer";
import { useState } from "react";
import Menu from "./components/menu/Menu";
function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const clickHandle = ()=>{
    if (menuOpen === true){
      setMenuOpen(false)
    }
  }
  return (
    <div className = "app"  onClick = {clickHandle}>
      <Topbar menuOpen = {menuOpen} setMenuOpen = {setMenuOpen} />
      <Menu menuOpen = {menuOpen} setMenuOpen = {setMenuOpen}/>
      
      <div className="sections">
        <Home/>
        <div className="sectionContent">
          <Minting/>
          <Utility/>
          <History/>
          <Nokkers/>
          <Noktypes/>
          <Epilogue/>
          <Faq/>
          <Footer/>
        </div>
        
      </div>
    </div>
  );
}

export default App;
